import React, { useCallback, useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row, Spinner } from '@themesberg/react-bootstrap'
import moment from 'moment-timezone'
import { downloadXlsx, FULL_LIST_ITEM_PER_PAGE } from "../helper/helper"

const toInputDate = (value) => value ? moment(value).format('YYYY-MM-DD') : ''

export default (props) => {

  const { show, onHide, fetchPage, showDateFilter = true, defaultFrom, defaultTo } = props

  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [running, setRunning] = useState(false)
  const [rowCount, setRowCount] = useState(0)

  useEffect(() => {
    if (show) {
      setFrom(toInputDate(defaultFrom))
      setTo(toInputDate(defaultTo))
      setRunning(false)
      setRowCount(0)
    }
  }, [show, defaultFrom, defaultTo])

  const _onHide = useCallback(() => {
    if (running) {
      alert('Chưa xuất file xong')
      return
    }
    onHide()
  }, [running, onHide])

  const _startExport = useCallback(async () => {
    if (showDateFilter && (!from || !to)) {
      alert('Vui lòng chọn Từ ngày và Đến ngày')
      return
    }

    setRunning(true)
    setRowCount(0)

    try {
      let page = 0
      let rows = []

      while (true) {
        const response = await fetchPage(page, { from, to })

        if (!response) {
          alert('Có lỗi xảy ra khi xuất file, vui lòng thử lại')
          return
        }

        rows = rows.concat(response.rows || [])
        setRowCount(rows.length)

        if ((response.count || 0) < FULL_LIST_ITEM_PER_PAGE) {
          break
        }

        page += 1
      }

      if (rows.length === 0) {
        alert('Không có dữ liệu để xuất')
        return
      }

      downloadXlsx(rows, onHide)
    } finally {
      setRunning(false)
    }
  }, [showDateFilter, from, to, fetchPage, onHide])

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Xuất file Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showDateFilter && (
          <Row className="mb-3">
            <Col sm={6}>
              <Form.Label>Từ ngày</Form.Label>
              <Form.Control
                type="date"
                value={from}
                disabled={running}
                onChange={(e) => setFrom(e.target.value)}
              />
            </Col>
            <Col sm={6}>
              <Form.Label>Đến ngày</Form.Label>
              <Form.Control
                type="date"
                value={to}
                disabled={running}
                onChange={(e) => setTo(e.target.value)}
              />
            </Col>
          </Row>
        )}
        {running && (
          <div className="d-flex align-items-center gap-2">
            <Spinner animation="border" size="sm" />
            <span>Đang xuất... đã lấy <b>{rowCount}</b> dòng</span>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={_startExport} disabled={running}>
          {running ? 'Đang xuất...' : 'Xuất file'}
        </Button>
        <Button variant="danger" onClick={_onHide} disabled={running}>Đóng</Button>
      </Modal.Footer>
    </Modal>
  );
}
